<template>
  <div class="covid-info-banner">
    <div class="container">
      <div class="covid-info">
        <div @click="handleExpand()" class="covid-info__header">
          <div class="d-flex f-aic">
            <span class="svg-icon mr-8" aria-hidden="true">
              <svg
                class="svg-icon__svg"
                width="16"
                height="16"
                focusable="false"
              >
                <use xlink:href="/img/static/svg-sprites.svg#icon-info"></use>
              </svg>
            </span>
            Warunki podróżowania podczas COVID-19
          </div>
          <div class="ml-16">
            <span :class="{ _flip: isExpanded }" class="up-down-arrow">
              <span></span><span></span>
            </span>
          </div>
        </div>
        <transition name="slide">
          <div v-show="isExpanded" class="covid-info__content">
            Dokumenty, testy, kwarantanna - wszystko, co musisz wiedzieć
            planując wakacje.
            <span class="text-link" @click="openUrl()"
              >Sprawdź aktualne informacje dla podróżujących</span
            >.
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "covid-header-info",
  data: () => ({
    isExpanded: false,
  }),
  methods: {
    openUrl() {
      window.open(
        "https://www.travelplanet.pl/blog/covid-19-aktualne-informacje-dla-podrozujacych/",
        "_blank"
      );
    },
    handleExpand() {
      this.isExpanded = !this.isExpanded;
    },
  },
};
</script>

<style lang="scss" scoped>
.covid-info-banner {
  background-color: #fffbe6;
  border-bottom: 1px solid darken(#fffbe6, 12%);
}

.covid-info {
  @media (max-width: $screen-xs-max) {
    font-size: 14px;
  }

  &__header {
    @include font-m();
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
    padding-bottom: 8px;

    .svg-icon__svg {
      fill: $blue-light;
    }
  }

  &__content {
    overflow: hidden;
    max-height: 100px;
    padding-bottom: 8px;

    @media (min-width: $screen-xxs) {
      max-height: 68px;
    }

    @media (min-width: $screen-sm) {
      max-height: 54px;
    }

    @media (min-width: $screen-md) {
      max-height: 40px;
    }
  }
}

// Slide animation
.slide-enter-active,
.slide-leave-active {
  transition: all 0.05s linear;
}

.slide-enter,
.slide-leave-to {
  max-height: 0;
}
</style>
